/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface ProgressPoint {
  readonly recordedAt: string;
  readonly accuracyPct: number;
  readonly correct: number;
  readonly incorrect: number;
  readonly prompted: number;
}

export interface GoalProgress {
  readonly goalId: string;
  readonly title: string;
  readonly category: string | null;
  readonly targetDate: string | null;
  readonly points: readonly ProgressPoint[];
}

export type TimelineKind = 'session_completed' | 'plan_version' | 'goal_achieved';

export interface TimelineEntry {
  readonly kind: TimelineKind;
  readonly at: string;
  readonly title: string;
  readonly refId: string;
}

export const progressApi = {
  async forClient(clientId: string): Promise<readonly GoalProgress[]> {
    const { data } = await apiClient.get<readonly GoalProgress[]>(`/clients/${clientId}/progress`);
    return data;
  },
  async timeline(clientId: string): Promise<readonly TimelineEntry[]> {
    const { data } = await apiClient.get<readonly TimelineEntry[]>(`/clients/${clientId}/timeline`);
    return data;
  },
};
